module.exports = __webpack_public_path__ + "static/ocorie-abt-6-f624b98baf4792baa8af7069dcbd18dc.png";